const initialState = null;

const showEditModalReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_EDIT_MODAL':
            return action.payload.todo ? action.payload.todo : null;
        default:
             return state;
    }
};

export default showEditModalReducer;
